import script from "./RandomFileForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RandomFileForm.vue?vue&type=script&setup=true&lang=js"

import "./RandomFileForm.vue?vue&type=style&index=0&id=7bd127b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bd127b9"]])

export default __exports__